var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgListingIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10879_9006)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 1.24499C13 0.557403 12.4426 0 11.755 0H1.24499C0.557403 0 0 0.557403 0 1.24499V11.755C0 12.4426 0.557403 13 1.24499 13H11.755C12.4426 13 13 12.4426 13 11.755L13 1.24499ZM1.25974 1.00882H11.7722C11.9019 1.00882 11.9912 1.09672 11.9912 1.22636V7.1458H8.94395C8.66504 7.1458 8.439 7.36218 8.439 7.64104C8.439 8.74083 7.54424 9.63077 6.44445 9.63077C5.3723 9.63077 4.49503 8.77809 4.45158 7.71641C4.45602 7.68953 4.45831 7.6704 4.45831 7.64227C4.45831 7.3634 4.23224 7.1458 3.95336 7.1458H1.00882V1.22636C1.00882 1.09672 1.13011 1.00882 1.25974 1.00882ZM11.7722 11.9912H1.25974C1.13011 11.9912 1.00882 11.8685 1.00882 11.7388V8.15461H3.48243C3.7232 9.56849 4.95978 10.6541 6.44445 10.6541C7.92909 10.6541 9.16568 9.56849 9.40644 8.15461H11.9912V11.7388C11.9912 11.8685 11.9019 11.9912 11.7722 11.9912Z",
    fill: "#DE1186"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.65046 3.35513H9.35639C9.63527 3.35513 9.86133 3.12961 9.86133 2.85072C9.86133 2.57184 9.63527 2.34631 9.35639 2.34631H3.65046C3.37157 2.34631 3.14551 2.57184 3.14551 2.85072C3.14551 3.12961 3.37157 3.35513 3.65046 3.35513Z",
    fill: "#DE1186"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.65046 5.67837H9.35639C9.63527 5.67837 9.86133 5.45284 9.86133 5.17396C9.86133 4.89509 9.63527 4.66956 9.35639 4.66956H3.65046C3.37157 4.66956 3.14551 4.89509 3.14551 5.17396C3.14551 5.45284 3.37157 5.67837 3.65046 5.67837Z",
    fill: "#DE1186"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10879_9006"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListingIcon);
export default __webpack_public_path__ + "static/media/listing-icon.995c4416de060ead6ba7651ddc01a73e.svg";
export { ForwardRef as ReactComponent };